const Email = (value) => {
    const emailRegex = /(^[a-zA-Z0-9_-]+)((\.*[a-zA-Z0-9_-])*)@([a-zA-Z0-9-_]+)((\.*[a-zA-Z0-9_-])*)(\.[a-zA-Z]{2,}$)/;
    return emailRegex.test(value);
};

const ConfirmEmail = (v1, v2) => {
    return v1 === v2;
};

const Mobile = (value) => {
    const mobileRegex = /\((\d{3})\) (\d{3})-(\d{4})/;
    return mobileRegex.test(value);
};

// Todo: update landline regex
const Landline = (value) => {
    const mobileRegex = /\((\d{3})\) (\d{3})-(\d{4})/;
    return mobileRegex.test(value);
};

const Password = (value) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*]).{8,}$/gm;
    return passwordRegex.test(value);
};

const ConfirmPassword = (v1, v2) => {
    return v1 === v2;
};

const DOB = (v) => {
    const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    return dobRegex.test(v);
};

const SSN = (v) => {
    const ssnRegex = /(\d{3}|\*{3})-(\d{2}|\*{2})-(\d{4})/;
    return ssnRegex.test(v);
};

const NPN = (v) => {
    const npnRegex = /^\d{5,10}$/;
    return npnRegex.test(v);
};

const SecurityCode = (v) => {
    const secCode = /^\d{6}$/;
    return secCode.test(v);
};




const Validators = {
    Email,
    ConfirmEmail,
    Mobile,
    Landline,
    Password,
    ConfirmPassword,
    DOB,
    SSN,
    NPN,
    SecurityCode
};

export default Validators;